// extracted by mini-css-extract-plugin
export default {"wrapper":"OnboardingContent_wrapper__CAshY","logo":"OnboardingContent_logo__gb4Qx"};